module.exports = __webpack_public_path__ + "static/media/magnifier.b12194c4.svg";